const editAboutUsConstantsEn = {
  AboutUsPageTitle: 'About Us',
  AboutUsBreadcrumb: 'ABOUT US',
};

export default editAboutUsConstantsEn;
